"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = __importDefault(require("../base/model"));
const company_schema_1 = require("./company.schema");
const __1 = require("../");
const aws_sdk_1 = require("aws-sdk");
const kumodi_1 = require("../_sdk/kumodi");
const athena_client_1 = __importDefault(require("@missionlabs/athena-client"));
class Company extends model_1.default {
    constructor() {
        super(...arguments);
        this._credentials = {};
    }
    isKeyAllowed(key) {
        return key !== 'aws' && key !== 'athena';
    }
    serialize() {
        let company = super.serialize();
        company.plugins = (company.plugins || []).map((plugin) => {
            return Object.assign(Object.assign({}, plugin), { auth: undefined });
        });
        company.instances = company.instances.map((instance) => {
            return Object.assign(Object.assign({}, instance), { aws: undefined });
        });
        //Client secret is only for the server
        if (company.ad) {
            company.ad = Object.assign(Object.assign({}, company.ad), { clientSecret: undefined });
        }
        //kumodi API key is only for the server
        if (company.kumodi) {
            company.kumodi = Object.assign(Object.assign({}, company.kumodi), { apiKey: undefined });
        }
        company = __1.utils.removePropertiesContaining(company, [
            'secret',
            'externalID',
            'accessKey',
            'private'
        ]);
        return company;
    }
    async getCredentials(instanceID, RoleSessionName) {
        const cachedCredentials = this._credentials[instanceID];
        if ((cachedCredentials === null || cachedCredentials === void 0 ? void 0 : cachedCredentials.expiry) > new Date(Date.now() + 1000)) {
            return cachedCredentials;
        }
        const instance = this.getInstance(instanceID);
        if (!instance)
            throw 'Instance not found';
        const credentials = await __1.utils.getCredentials(instance.roleName || 'smartagent', instance.accountID, instance.externalID || '', instance.region || 'eu-west-2', RoleSessionName || process.env.SMARTAGENT_USER);
        this._credentials[instanceID] = credentials;
        return credentials;
    }
    getInstance(instanceID) {
        return this.instances.find(i => i.ID === instanceID);
    }
    async getConnectInstance(instanceID) {
        if (this.callProvider === "kumodi") {
            if (!this.kumodi)
                throw new Error("Company misconfigured: callProvider = kumodi but no kumodi field on company");
            return new kumodi_1.Kumodi(this.kumodi);
        }
        const credentials = await this.getCredentials(instanceID);
        return new aws_sdk_1.Connect(credentials);
    }
    async getAthenaClient() {
        const { athena } = this;
        if (!athena) {
            throw new Error('No athena config against company');
        }
        const clientConfig = {
            bucketUri: 's3://' + athena.results,
            database: athena.database || 'smartagent_data_warehouse',
        };
        const credentials = await __1.utils.getCredentials(athena.roleName || 'smartagent-data', athena.accountID, athena.externalID, athena.region || 'eu-west-2');
        return athena_client_1.default.createClient(clientConfig, credentials);
    }
    ;
}
exports.default = Company;
Company.schema = company_schema_1.CompanySchema;
